import { useNavigate } from "react-router-dom";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemMedia,
} from "@volca/ui/components/ui/item";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { SIDEBAR_MODES } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { DetailedUserWithStats } from "@/user/user.d";
import { isTech } from "@/user/utils";

const RANK_TO_MEDAL = {
  1: "🥇",
  2: "🥈",
  3: "🥉",
};

interface SignupLeaderboardItemProps {
  user: DetailedUserWithStats;
  rank: number | null;
  showRank: boolean;
  isLast: boolean;
  businessId: string;
}

export const SignupLeaderboardItem = ({
  user,
  rank,
  showRank,
  isLast,
  businessId,
}: SignupLeaderboardItemProps) => {
  const navigate = useNavigate();
  const { updateSidebar } = useBusinessSettingsSidebar();
  const medal = rank ? RANK_TO_MEDAL[rank as keyof typeof RANK_TO_MEDAL] : null;

  return (
    <Item
      render={<button type="button" />}
      size="xs"
      className={cn("h-12 flex-nowrap rounded-none px-4 text-left", {
        "border-b-line": !isLast,
      })}
      onClick={() => {
        void navigate(
          `/business-settings/${businessId}/users/${isTech(user.role) ? "technicians" : "web-app-users"}`,
        );
        updateSidebar({
          section: isTech(user.role) ? "technicians" : "users",
          mode: SIDEBAR_MODES.view,
          selectedItemId: user.id,
          isOpen: true,
        });
      }}
    >
      {showRank && (
        <ItemMedia className="w-8">
          {medal ? (
            <Text variant="display" className="text-center">
              <span role="img" aria-label={`Rank ${rank}`}>
                {medal}
              </span>
            </Text>
          ) : (
            rank && (
              <Text variant="title" className="text-center">
                {rank}
              </Text>
            )
          )}
        </ItemMedia>
      )}
      <ItemContent>
        <Text
          className="line-clamp-2"
          title={`${user.first_name} ${user.last_name}`}
        >
          {user.first_name} {user.last_name}
        </Text>
      </ItemContent>
      <ItemActions>
        <Text className="tabular-nums">{user.stats?.signup_count ?? 0}</Text>
      </ItemActions>
    </Item>
  );
};
